import { reportErrorToPosthog } from "@fideus/analytics";
import { createI18nInit } from "@fideus/i18n";

const isTest = import.meta.env.MODE === "test";

export const { i18n, i18nInitPromise } = createI18nInit({
  missingKeyHandler: isTest
    ? undefined
    : (_lngs: readonly string[], ns: string, key: string) => {
        reportErrorToPosthog(new Error(`Missing translation: ${ns}:${key}`));
      },
});
